import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';

import { HRRoutingModule } from './hr-routing.module';

import { HRComponent } from './hr.component';
import { DashboardComponent } from './selfService/dashboard.component';
import { EmployeeComponent } from './employee/employee.component';
import { ViewEmployeesComponent } from './employee/viewEmployees.component'
import { HrConfigComponent } from './hrConfig/hrConfig.component'
import { ReportingComponent } from './reporting/reporting.component';
import { PSCComponent } from './psc/psc.component';
import { PscGenerateFiscalPayComponent } from './psc/pscGenerateFiscalPay.component';
import { PscWsLeadReviewQueueComponent } from './psc/pscWsLeadReviewQueue.component';
import { PscDmApprovalQueueComponent } from './psc/pscDmApprovalQueue.component';
import { PscHrmApprovalQueueComponent } from './psc/pscHrmApprovalQueue.component';
import { PscPmmApprovalQueueComponent } from './psc/pscPmmApprovalQueue.component';
import { PscAcctReceivalQueueComponent } from './psc/pscAcctReceivalQueue.component';
import { PscItReceivalQueueComponent } from './psc/pscItReceivalQueue.component';
import { PscHrRoutingQueueComponent } from './psc/pscHrRoutingQueue.component';
import { PscHrRejectedQueueComponent } from './psc/pscHrRejectedQueue.component';
import { PscHrmRejectedQueueComponent } from './psc/pscHrmRejectedQueue.component';
import { PscHrAcceptedQueueComponent } from './psc/pscHrAcceptedQueue.component';
import { PscHrmAcceptedQueueComponent } from './psc/pscHrmAcceptedQueue.component';
import { PscAcctReceivedQueueComponent } from './psc/pscAcctReceivedQueue.component';
import { EmployeeTrainingComponent } from './training/employeeTraining.component';
import { MyTrainingComponent } from './training/myTraining.component';
import { TrainingConfigComponent } from './trainingConfig/trainingConfig.component';
import { SelfTrainedCertQueueComponent } from './trainingReview/selfTrainedCertQueue';
import { TrainerCertQueueComponent } from './trainingReview/trainerCertQueue';
import { QualApprovalQueueComponent } from './trainingReview/qualApprovalQueue';
import { ReportingTrainingComponent } from './reporting/reportingTraining.component';
import { ClearanceStatusTableComponent } from './hrConfig/clearance-status-table/clearance-status-table.component';
import { DepartmentsTableComponent } from './hrConfig/departments-table/departments-table.component';
import { EeoTypeTableComponent } from './hrConfig/eeo-type-table/eeo-type-table.component';
import { EmployeeJobAssignmentsTableComponent } from './hrConfig/employee-job-assignments-table/employee-job-assignments-table.component';
import { EmployeeStatusTableComponent } from './hrConfig/employee-status-table/employee-status-table.component';
import { EmploymentStatusTableComponent } from './hrConfig/employment-status-table/employment-status-table.component';
import { EmploymentTypeTableComponent } from './hrConfig/employment-type-table/employment-type-table.component';
import { FyPayRatesTableComponent } from './hrConfig/fy-pay-rates-table/fy-pay-rates-table.component';
import { GenderTypeTableComponent } from './hrConfig/gender-type-table/gender-type-table.component';
import { JobCategoriesTableComponent } from './hrConfig/job-categories-table/job-categories-table.component';
import { JobTitlesTableComponent } from './hrConfig/job-titles-table/job-titles-table.component';
import { MaritalStatusTableComponent } from './hrConfig/marital-status-table/marital-status-table.component';
import { OccStatusTableComponent } from './hrConfig/occ-status-table/occ-status-table.component';
import { OtherSpecialtyTypeTableComponent } from './hrConfig/other-specialty-type-table/other-specialty-type-table.component';
import { PscTypeTableComponent } from './hrConfig/psc-type-table/psc-type-table.component';
import { ShareholderTypeTableComponent } from './hrConfig/shareholder-type-table/shareholder-type-table.component';
import { UnionAffiliationTableComponent } from './hrConfig/union-affiliation-table/union-affiliation-table.component';
import { WorkSectionsTableComponent } from './hrConfig/work-sections-table/work-sections-table.component';
import { MatChipsModule} from '@angular/material/chips';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { TrainingBaseComponent } from './training/training-base.component';
import { CertificationQueueBaseComponent } from './trainingReview/certification-queue-base.component';
import { CompletedTrainingDialogComponent } from './training/completed-training-dialog/completed-training-dialog.component';
import { RevokeApprovalCommentDialogComponent } from './training/revoke-approval-comment-dialog/revoke-approval-comment-dialog.component';
import { RevokeCommentDialogComponent } from './training/revoke-comment-dialog/revoke-comment-dialog.component';
import { NewQualQualTaskDialogComponent } from './trainingConfig/new-qual-qual-task-dialog/new-qual-qual-task-dialog.component';
import { NewQualJobTitleDialogComponent } from './trainingConfig/new-qual-job-title-dialog/new-qual-job-title-dialog.component';
import { NewQualJobAssignmentDialogComponent } from './trainingConfig/new-qual-job-assignment-dialog/new-qual-job-assignment-dialog.component';
import { NewQualTaskQualDialogComponent } from './trainingConfig/new-qual-task-qual-dialog/new-qual-task-qual-dialog.component';
import { NewQualTaskPrerequisiteDialogComponent } from './trainingConfig/new-qual-task-prerequisite-dialog/new-qual-task-prerequisite-dialog.component';
import { NewQualTaskTrainerDialogComponent } from './trainingConfig/new-qual-task-trainer-dialog/new-qual-task-trainer-dialog.component';
import { NewTrainerQualTaskDialogComponent } from './trainingConfig/new-trainer-qual-task-dialog/new-trainer-qual-task-dialog.component';
import { NewReqQualForEmpDialogComponent } from './trainingConfig/new-req-qual-for-emp-dialog/new-req-qual-for-emp-dialog.component';
import { PscRejectCommentDialogComponent } from './psc/psc-reject-comment-dialog/psc-reject-comment-dialog.component';
import { NewReqQualForMultipleEmpsDialogComponent } from './trainingConfig/new-req-qual-for-multiple-emps-dialog/new-req-qual-for-multiple-emps-dialog.component';

@NgModule({
  imports: [
    SharedModule,
    HRRoutingModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatInputModule
  ],
  declarations: [
    HRComponent,
    DashboardComponent,
    EmployeeComponent,
    ViewEmployeesComponent,
    HrConfigComponent,
    ReportingComponent,
    PSCComponent,
    PscGenerateFiscalPayComponent,
    PscWsLeadReviewQueueComponent,
    PscDmApprovalQueueComponent,
    PscHrmApprovalQueueComponent,
    PscPmmApprovalQueueComponent,
    PscAcctReceivalQueueComponent,
    PscItReceivalQueueComponent,
    PscHrRoutingQueueComponent,
    PscHrRejectedQueueComponent,
    PscHrmRejectedQueueComponent,
    PscHrAcceptedQueueComponent,
    PscHrmAcceptedQueueComponent,
    PscAcctReceivedQueueComponent,
    MyTrainingComponent,
    EmployeeTrainingComponent,
    TrainingConfigComponent,
    SelfTrainedCertQueueComponent,
    TrainerCertQueueComponent,
    QualApprovalQueueComponent,
    ReportingTrainingComponent,
    ClearanceStatusTableComponent,
    DepartmentsTableComponent,
    EeoTypeTableComponent,
    EmployeeJobAssignmentsTableComponent,
    EmployeeStatusTableComponent,
    EmploymentStatusTableComponent,
    EmploymentTypeTableComponent,
    FyPayRatesTableComponent,
    GenderTypeTableComponent,
    JobCategoriesTableComponent,
    JobTitlesTableComponent,
    MaritalStatusTableComponent,
    OccStatusTableComponent,
    OtherSpecialtyTypeTableComponent,
    PscTypeTableComponent,
    ShareholderTypeTableComponent,
    UnionAffiliationTableComponent,
    WorkSectionsTableComponent,
    TrainingBaseComponent,
    CertificationQueueBaseComponent,
    CompletedTrainingDialogComponent,
    RevokeApprovalCommentDialogComponent,
    RevokeCommentDialogComponent,
    NewQualQualTaskDialogComponent,
    NewQualJobTitleDialogComponent,
    NewQualJobAssignmentDialogComponent,
    NewQualTaskQualDialogComponent,
    NewQualTaskPrerequisiteDialogComponent,
    NewQualTaskTrainerDialogComponent,
    NewTrainerQualTaskDialogComponent,
    NewReqQualForEmpDialogComponent,
    PscRejectCommentDialogComponent,
    NewReqQualForMultipleEmpsDialogComponent,
  ]
})
export class HRModule { }
